import { client } from '@@api/client';
import { CONTENT_LANGUAGE_HEADER } from '@@api/constants/headers';
import { type ContentLanguage } from '@@lib/i18n/constants';

export const categoryListQuery = (
    query: { q?: string; active?: boolean; syncedWithDesknet?: boolean },
    contentLocale: ContentLanguage,
) => {
    const { q, ...filters } = query;

    return client.tenant.category.getAll.queryOptions({
        query: { sort: 'name,ASC', name: q, ...filters },
        headers: { [CONTENT_LANGUAGE_HEADER]: contentLocale },
    });
};
